import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cash_document_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    cash_document_hdr_stmt_no: fromDatatype.VarcharDatatypeInterface;
    cash_document_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_code: fromDatatype.VarcharDatatypeInterface;
    payment_method_type_guid: fromDatatype.GuidDataFieldInterface;
    payment_method_type_code: fromDatatype.VarcharDatatypeInterface;
    payee_payor: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    cheque_date: fromDatatype.TimestampTzDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    settlement_type:fromDatatype.VarcharDatatypeInterface;
    line_type:fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_cash_document_line_RowClass implements bl_fi_cash_document_line_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    cash_document_hdr_stmt_no: fromDatatype.VarcharDatatypeInterface;
    cash_document_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_code: fromDatatype.VarcharDatatypeInterface;
    payment_method_type_guid: fromDatatype.GuidDataFieldInterface;
    payment_method_type_code: fromDatatype.VarcharDatatypeInterface;
    payee_payor: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    cheque_date: fromDatatype.TimestampTzDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    settlement_type:fromDatatype.VarcharDatatypeInterface;
    line_type:fromDatatype.VarcharDatatypeInterface;
}